import React from 'react';

/**
 * User Status Badge Component
 * 
 * Displays a colored status indicator for user presence
 */
const UserStatusBadge = ({ status = 'offline', size = 'sm', showLabel = false, style = {} }) => {
  const statusColors = {
    active: '#10b981',   // Green
    online: '#10b981',   // Green
    idle: '#f59e0b',     // Amber
    offline: '#6b7280',  // Gray
    unknown: '#6b7280'   // Gray
  };

  const sizes = {
    xs: { dot: 6, label: 11 },
    sm: { dot: 8, label: 12 },
    md: { dot: 10, label: 13 },
    lg: { dot: 12, label: 14 }
  };

  const { dot: dotSize, label: labelSize } = sizes[size] || sizes.sm;
  const color = statusColors[status] || statusColors.unknown;
  const displayStatus = status === 'active' ? 'online' : status;

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        ...style
      }}
      title={`Status: ${displayStatus}`}
    >
      <span
        style={{
          width: dotSize,
          height: dotSize,
          borderRadius: '50%',
          backgroundColor: color,
          display: 'inline-block',
          boxShadow: status === 'active' || status === 'online' ? `0 0 ${dotSize}px ${color}40` : 'none',
          animation: status === 'active' || status === 'online' ? 'pulse 2s infinite' : 'none'
        }}
      />
      {showLabel && (
        <span
          style={{
            fontSize: labelSize,
            color: '#374151',
            textTransform: 'capitalize',
            fontWeight: 500
          }}
        >
          {displayStatus}
        </span>
      )}
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.6; }
        }
      `}</style>
    </span>
  );
};

export default UserStatusBadge;
